import React, { useState, useRef, useEffect } from "react";
//import SearchIcon from "@material-ui/icons/Search";
import { useHistory } from "react-router-dom";
import "./Header.css";
import { NavLink } from "react-router-dom";
//---------------------------------------------------------------------
import ReorderIcon from "@material-ui/icons/Reorder";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
//import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import StoreIcon from "@material-ui/icons/Store";
//----------------------------------------------------------------------------

function Header() {
  //---------------------------------------------------------------------------------
  const history = useHistory();
  //----------------------------------------------------------------------------
  const [showLinks, setShowLinks] = useState(false);
  //---------------------------------------------------------------------------------
  // this section is closing 'dropdown' when mouse is clicked any where in document. 'useRef' hook is used here.
  const dropdownRef = useRef();
  useEffect(() => {
    let handler = (event) => {
      if (!dropdownRef.current.contains(event.target)) {
        setShowLinks(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, []);
  //---------------------------------------------------------------------------------
  return (
    <div className="Navbar">
      <div className="leftSide">
        <div ref={dropdownRef} className="links">
          {/*-----------------------------landing Page----------------------------*/}
          <NavLink
            to="/"
            className="landingPage"
            exact
            activeClassName="selected"
            id={showLinks ? "hidden" : ""}
            /* same function is written in a different way in following two cases below */
            onClick={() =>
              showLinks ? setShowLinks(false) : setShowLinks(true)
            }
          >
            <StoreIcon />
          </NavLink>
          {/*---------------------SignIn------------------------*/}
          <NavLink
            to="/aboutus"
            className="aboutUs"
            exact
            activeClassName="selected"
            id={showLinks ? "hidden" : ""}
            onClick={() => setShowLinks(!showLinks)}
          >
            About Us
          </NavLink>

          {/*-----------------------Contact Us-------------------------------*/}
          <NavLink
            to="/contactus"
            className="contactUsPage"
            exact
            activeClassName="selected"
            id={showLinks ? "hidden" : ""}
            onClick={() => setShowLinks(!showLinks)}
          >
            Contact Us
          </NavLink>
          {/*-------------this function is a toggle function---------*/}
          <button
            className="recorder_icon"
            onClick={() => setShowLinks(!showLinks)}
          >
            <ReorderIcon />
          </button>
        </div>
      </div>
      {/*---------------------Middle section menubar------------------------*/}
      {/*&nbsp; has joined two words not to wrap in between */}
      <div className="midSection">
        Online Electrical
        <br />
        E-shop
      </div>

      {/*-----------------------right side menubar starts-------------------*/}
      <div className="rightSide">
        {/*---------------shop title starts----------------
        <div className="shop_name">Baranagar Kolkata</div>
        {/*---------------shop title ends------------------*/}
        {/*---------back to previous page starts-----------*/}
        {/* the second line 'onClick' function closes the dwropdown menu if opened */}
        <div
          className="backTo"
          onClick={() => {
            history.goBack();
            /*showLinks && setShowLinks(!showLinks);*/
          }}
        >
          <span className="backIcon_details">Back</span>
          <KeyboardBackspaceIcon />
        </div>
        {/*-------------------back to previous page ends-------------*/}
      </div>
    </div>
  );
}

export default Header;
